export default class {

    constructor() {
        this.rxjs_subject = window.rxjs_subject;
        this.message = {
            changeTickets: "changeTickets",
            flightmodal: "flightmodal"
        };
    }

    getMessage(key) {
        // debugger;
        return this.message[key];
    }
    getSubject() {
        return this.rxjs_subject;
    }

}